import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import loaderimage from '../../../images/giphy.gif';
import ConfirmationModal from "../../shared/ConfirmationModal";
import NewconfirmationModal from "../../shared/NewconfirmationModal";
import AllFailureModal from "../../shared/AllFailureModal";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface Contact {
  contact_srno: number;
  name: string;
  email: string;
  mobile: string;
  subject: string;
  message: string;
  isactive: number;
  userid: number; 
  contactid: number;
}

const ContactList = () => {
  const [contactlist, setContacts] = useState<Contact[]>([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false); 
  const [modalMessage, setModalMessage] = useState(""); 
  const [operationType, setOperationType] = useState(""); 
  const [contactToDelete, setContactToDelete] = useState<number | null>(null); 
  const [contactToToggle, setContactToToggle] = useState<number | null>(null);
  const [newStatus, setNewStatus] = useState<number | null>(null);
  const [filteredContact, setFilteredContact] = useState<Contact[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
  
    const [showFailureModal, setShowFailureModal] = useState(false);
    const [failureMessage, setFailureMessage] = useState("");

    const headers = {
      "x-access-token": localStorage.getItem("jwttoken") || "",
    };
  const fetchContactList = async () => {
    try {
      setLoader(true);
      setError(null);
      const url = process.env.REACT_APP_API_URL + 'contact/getcontacts';
      const response = await axios.get(url,{headers});
      setContacts(response.data);
      setFilteredContact(response.data);
    } catch (error) {
      console.log(error);
      setError("Oops! Something went wrong. Please try again later.");
    }finally {
      setLoader(false);
    }
  };

  const deleteContact = async () => {
    if (!contactToDelete) {
      console.error("No contact selected for deletion.");
      setFailureMessage("No contact selected for deletion.");
      setShowFailureModal(true);
      return;
    }
  
    try {
      setLoader(true);
      const url = process.env.REACT_APP_API_URL + 'contact/deletecontact/' + contactToDelete;
      await axios.delete(url, { headers });
      setSuccessMessage("Contact deleted successfully!");
      setShowSuccessModal(true);
      fetchContactList(); 
    } catch (error) {
      console.error("Error deleting contact:", error);
      setFailureMessage("Error deleting contact.");
      setShowFailureModal(true);
    } finally {
      setLoader(false);
    }
    setShowModal(false);
  };

  const handleToggleRequest = (contactId: number, currentStatus: number) => {
    const newStatusValue = currentStatus === 2 ? 1 : 2;
    const statusText = newStatusValue === 1 ? "Reached" : "Pending";
    
    setContactToToggle(contactId);
    setNewStatus(newStatusValue);
    setModalMessage(`Are you sure you want to change the status to ${statusText}?`);
    setOperationType("Confirm");
    setShowModal(true);
  };

  const toggleIsactive = async (contactId: number, currentStatus: number) => {
    try {
      //console.log("Inside toggle function for:", contactId);
      const url = `${process.env.REACT_APP_API_URL}contact/toggleisactive/${contactId}`;
      const response = await axios.put(url, {
        isactive: currentStatus === 2 ? 1 : 2, 
      });
  
      if (response.status === 200) {
        setSuccessMessage("Status changed successfully!");
        setShowSuccessModal(true);
        
        setContacts((prevList) =>
          prevList.map((item) =>
            item.contactid === contactId
              ? { ...item, isactive: currentStatus === 2 ? 1 : 2 }
              : item
          )
        );
        setFilteredContact((prevList) =>
          prevList.map((item) =>
            item.contactid === contactId
              ? { ...item, isactive: currentStatus === 2 ? 1 : 2 }
              : item
          )
        );
      } else {
        console.error("Failed to update status:", response);
        setFailureMessage("Failed to update status. Please try again.");
        setShowFailureModal(true);
      }
    } catch (error) {
      console.error("Error toggling isactive status:", error);
      setFailureMessage("An error occurred while updating the status. Please try again.");
      setShowFailureModal(true);
    } finally {
      setLoader(false);
    }
  };
  
  

  useEffect(() => {
    fetchContactList();
  }, []);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.toLowerCase();
      setSearchTerm(value);
    };

    useEffect(() => {
      const debounceTimeout = setTimeout(() => {
        if (searchTerm === "") {
          setFilteredContact(contactlist);
        } else {
          const filtered = contactlist.filter(
            (user) =>
              user?.name?.toLowerCase().includes(searchTerm) ||
              user?.email?.toLowerCase().includes(searchTerm)
          );
          setFilteredContact(filtered);
        }
      }, 300);
      return () => clearTimeout(debounceTimeout);
    }, [searchTerm, contactlist]);

  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="text-dark fw-bold">Contact Management</h2>
            <div className="d-flex gap-2 align-items-center">
                <span className="fw-bold text-secondary text-nowrap">{filteredContact.length} results</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Name or Contactname or Email"
                  value={searchTerm}
                  onChange={handleSearch}
                />
              <Link to="/ContactAdd" className="btn bg-info">+ Add Contact</Link>
            </div>
      </div>
      <div className="card shadow-sm border-0 rounded">
        <div className="card-header bg-info border-bottom py-3">
          <h5 className="mb-0 text-white">Contact List</h5>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
            <table className="table table-hover align-middle mb-0">
              <thead className="bg-light">
                <tr>
                  <th>SrNo</th>
                  <th>Contact ID</th>
                  <th>Name</th>
                  <th>Userid</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Subject</th>
                  <th style={{ width: "400px" }}>Message</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={9} className="text-center py-2">
                        <img src={loaderimage} alt="Loading..." height="40" />
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                    <td colSpan={9} className="text-center text-danger fw-bold py-3">
                      <div className="alert alert-danger text-center m-3" role="alert">
                        Oops! Something went wrong. Please try again later.
                      </div>
                    </td>
                   </tr>
                  ) : filteredContact.length > 0 ? (
                    filteredContact.map((item, index) => (
                      <tr key={item.contactid}>
                        <td>{index + 1}</td>
                        <td>{item.contactid}</td>
                        <td>{item.name}</td>
                        <td>{item.userid}</td>
                        <td>{item.email}</td>
                        <td>{item.mobile}</td>
                        <td>{item.subject}</td>
                        <td className="text-wrap" style={{ maxWidth: "400px", whiteSpace: "normal" }}>
                         {item.message}
                        </td>
                    <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
        
                        <Link to={`/ContactView/${item.contactid}`} className="btn btn-sm btn-outline-success">
                        View
                        </Link>
                        <Link to={`/ContactEdit/${item.contactid}`} className="btn btn-sm btn-outline-warning">
                        Edit
                        </Link>
                        <button
                        onClick={() => handleToggleRequest(item.contactid, item.isactive)}
                        className={`btn btn-sm w-100 ${item.isactive === 2 ? "btn-outline-danger" : "btn-outline-success"}`}
                        >
                        {item.isactive === 1 ? "Reached" : "Pending"}
                        </button>

                        <button className="btn btn-sm btn-outline-secondary"
                        onClick={() => {
                        setContactToDelete(item.contactid);
                        setModalMessage("Are you sure you want to delete this contact?");
                        setOperationType("Delete");
                        setShowModal(true);
                        }}
                        >
                        Delete
                        </button>
                      </div>
                    </td>
                    </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center text-muted fw-bold">
                      <div className="alert alert-secondary text-center m-3" role="alert">
                        No Users Available
                      </div>
                    </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
        </div>
        </div>
  
      {/* ConfirmationModal */}
      {showModal && (
        <ConfirmationModal
          show={showModal}
          onHide={() => {
            setShowModal(false);
            if (operationType === "Ok") {
              fetchContactList();
            }
          }}
          modalMessage={modalMessage}
          operationType={operationType}
          confirmation={(confirmed: boolean) => {
            if (confirmed) {
              if (operationType === "Delete") {
                console.log("confirmed delete");
                deleteContact();
              } else if (operationType === "Confirm") {
                console.log("confirmed status change");
                if (contactToToggle !== null && newStatus !== null) {
                  toggleIsactive(contactToToggle, newStatus === 1 ? 2 : 1);
                }
              }
            }
            setShowModal(false);
          }}
        />
      )}
      <NewconfirmationModal 
        show={showSuccessModal} 
        onHide={() => setShowSuccessModal(false)} 
        modalMessage={successMessage} 
        operationType="OK" 
        timeoutDuration={3000} 
      />
      <AllFailureModal 
        show={showFailureModal} 
        onHide={() => setShowFailureModal(false)} 
        modalMessage={failureMessage} 
        operationType="OK" 
        timeoutDuration={5000} 
      />
    </div>
  );
};

export default ContactList;